// extracted by mini-css-extract-plugin
export default {"btn":"secondaryButton_btn__89WOLxWd","default":"secondaryButton_default__RQMI17Qk","active":"secondaryButton_active__e2l0VVmT"};